module.exports = __webpack_public_path__ + "static/media/3.26a0fdf5.jpg";